
/**
 * 통화 코드
 */
export type UpdateCourseDraft200PriceCurrency = typeof UpdateCourseDraft200PriceCurrency[keyof typeof UpdateCourseDraft200PriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200PriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
